import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import DeviceDetector from "../../DeviceDetector";

gsap.registerPlugin(ScrollTrigger);
export default class OurGreatestHits {
  constructor() {
    this.deviceDetector = new DeviceDetector();
    this.isMobile = this.deviceDetector.isMobile();

    this.animationBG();
    this.animationHeading();
    this.animationDisk();
    this.animationFavourite();
  }

  animationBG() {
    if (this.isMobile === false) {
      this.bgTimeLine = gsap.timeline({
        scrollTrigger: {
          trigger: ".what-we-do__detail",
          start: "top bottom",
          end: "top top",
          scrub: true,
          markers: false,
        },
      });

      this.bgTimeLine.from(".background-green-smoke", {
        opacity: 0,
      });
    }
  }

  animationDisk() {
    if (this.isMobile === false) {
      this.diskTimeLine = gsap.timeline({
        scrollTrigger: {
          trigger: ".what-we-do__detail",
          start: "top bottom",
          end: "top center",
          scrub: true,
          markers: false,
        },
      });

      this.diskTimeLine
        .from(".disk-container", {
          scale: 0,
        })
        .to(".disk", {
          left: "79%",
        });
    } else {
      gsap.set(".disk-container", {
        left: "-33%",
      });
      gsap.set(".disk", {
        left: "79%",
      });
    }
  }

  animationHeading() {
    if (this.isMobile === false) {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: "#what-we-do__headings",
          start: "top 90%",
          end: "bottom 60%",
          scrub: true,
          markers: false,
        },
      });

      const elements = gsap.utils.toArray(".display-outline-green");
      tl.fromTo(
        elements,
        { opacity: 0, x: window.outerWidth / 4 },
        { opacity: 1, x: 0, stagger: 0.15 }
      );
    }

    // if (this.isMobile === false) {
    //   this.headings = gsap.utils.toArray(".tspan");
    //   this.headingsTimeLine = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: ".heading",
    //       start: "top bottom",
    //       end: "bottom center",
    //       scrub: true,
    //       markers: false,
    //     },
    //   });
    //
    //   this.headingsTimeLine.from(this.headings, {
    //     stagger: 0.15,
    //     opacity: 0,
    //     attr: {
    //       x: "100%",
    //     },
    //   });
    // }
  }

  animationFavourite() {
    if (this.isMobile === false) {
      this.favouriteTimeLine = gsap.timeline({
        scrollTrigger: {
          trigger: ".what-we-do__detail",
          start: "top bottom",
          end: "top center",
          scrub: true,
          markers: false,
        },
      });

      this.favouriteTimeLine.from(".favourite", {
        opacity: 0,
        y: 100,
      });
    }
  }
}
